// extracted by mini-css-extract-plugin
export default {"welcomeLayout":"index_welcomeLayout__ckfTi"};